<p>policy-payment-view works!</p>
